
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {EventBridge as EventBridgeService} from "@/simulation/EventBridge";

    @Component
    export default class EventBridge extends Vue {
        @Prop() private eventBridge!: EventBridgeService;
    }
